import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStyles } from './EditCommunityModal.styles.js';
import CircularProgress from '@mui/material/CircularProgress';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { useDropzone } from 'react-dropzone';
import { dragAndDropStyle } from '../pages/shared.styles';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch } from 'react-redux';
import { labelLength } from '../../constants/app.constants.js';
import BaseModalLayout from './BaseModalLayout.js';
import { showMessageV2 } from '../../utils/page.utils.js';

export default function EditCommunityModal(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();

  const [label, setLabel] = useState('');
  const [image, setImage] = useState(null);
  const [anonymous, setAnonymous] = useState(false);
  const [fontStyle, setFontStyle] = useState('TheJamsil');
  const { open, loading } = props;

  useEffect(() => {
    const defaultLanguage = localStorage.getItem('selectedLanguage') || navigator.language.split('-')[0];
    const defaultFont = defaultLanguage === 'ja' ? 'MPlus1' : 'TheJamsil';
    setFontStyle(defaultFont);
  }, []);

  useEffect(() => {
    setAnonymous(props.anonymous);
    setLabel(props.label);
  }, [props.label, props.anonymous]);

  const onDropRejected = async input => {
    const error = input[0].errors[0];
    if (error.code === 'file-invalid-type') {
      showMessageV2(dispatch, t('trainingTab.modal.notSupportedFileType'));
    }
  };

  const onImageDropAccepted = async acceptedFiles => {
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      setImage(file);
    }
  };

  const imgDropzone = useDropzone({
    accept: {
      'image/jpeg': [],
      'image/png': [],
      'image/webp': [],
      'image/heic': [],
      'image/jfif': [],
      'image/jpg': [],
    },
    maxFiles: 1,
    onDropAccepted: onImageDropAccepted,
    onDropRejected,
    disabled: loading,
  });

  const onClick = res => {
    if (!res) return props.onEditCommunityModalClose();

    if (label.length > labelLength.voice) {
      showMessageV2(dispatch, t('communityUploadTab.modal.longLabel'));
    } else if (label.length === 0) {
      showMessageV2(dispatch, t('communityUploadTab.modal.noLabel'));
    } else {
      props.onEdit(label, anonymous, image);
    }
    setImage(null);
  };
  return (
    <BaseModalLayout open={!!open} onClose={() => props.onEditCommunityModalClose()} sizeMax>
      <div className={classes.container}>
        {!loading && (
          <>
            <div className={classes.section}>
              <div className={classes.header}>{t('historyTab.modal.label')}</div>
              <input
                className={classes.labelInput}
                placeholder={t('communityUploadTab.stepThree.subTitle')}
                value={label}
                onChange={e => setLabel(e.target.value)}
              />
            </div>
            <div className={classes.section}>
              <div className={classes.header}>{t('historyTab.modal.username')}</div>
              <FormControl className={classes.radioButtonContainer}>
                <div className={classes.radioButtonLabel}>{t('communityUploadTab.stepThree.anonymousText')}</div>
                <RadioGroup row>
                  <FormControlLabel
                    className={classes.formControlLabel}
                    checked={anonymous}
                    control={
                      <Radio
                        size="small"
                        className={classes.radioButton}
                        disableRipple
                        onClick={() => setAnonymous(true)}
                      />
                    }
                    label={<div className={classes.formControlLabelText}>{t('yes')}</div>}
                  />
                  <FormControlLabel
                    className={classes.formControlLabel}
                    checked={!anonymous}
                    control={
                      <Radio
                        size="small"
                        className={classes.radioButton}
                        disableRipple
                        onClick={() => setAnonymous(false)}
                      />
                    }
                    label={<div className={classes.formControlLabelText}>{t('no')}</div>}
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div className={classes.section}>
              <div className={classes.header}>{t('historyTab.modal.image')}</div>
              {!image && (
                <div className={classes.dragAndDropContainer}>
                  <div {...imgDropzone.getRootProps({ style: dragAndDropStyle })}>
                    <input {...imgDropzone.getInputProps()} />
                    <div className={classes.dragAndDrop}>
                      <div className={classes.dragAndDropText}>
                        {t('communityUploadTab.stepOne.tabs.fileUpload.dragAndDropText')}
                      </div>
                      <div className={classes.dragAndDropText}>{'jpeg/png/webp/heic/jfif/jpg'}</div>
                      <div className={classes.dragAndDropButton}>
                        {t('inferenceTab.stepOne.tabs.fileUpload.dragAndDropButton')}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {image && (
                <div className={classes.imageContainer}>
                  <img src={URL.createObjectURL(image)} className={classes.coverImg} />
                  <DeleteIcon onClick={() => setImage(null)} className={classes.deleteButtonImg} />
                </div>
              )}
            </div>

            <div className={classes.buttonContainer}>
              <div className={`${classes.button} ${classes.yesButton}`} onClick={() => onClick(true)}>
                {t('historyTab.changeButton')}
              </div>
              <div className={`${classes.button} ${classes.noButton}`} onClick={() => onClick(false)}>
                {t('historyTab.cancelButton')}
              </div>
            </div>
          </>
        )}
        {loading && <CircularProgress className={classes.loading} />}
      </div>
    </BaseModalLayout>
  );
}
